import React from "react";
import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, link }: SvgIconProps) => (
  <img loading="lazy" src={`/img/svg/${src}`} alt={src} width={width} height={height} onClick={() => window.open(link, "_self")}
  />
);
